import Cookies from 'js-cookie';

interface CheckProfessionalAuthorizationProps {
	handleFailed?: () => void;
	handleProfessionalAuthorized?: () => void;
	handleProfessionalNotAuthorized?: () => void;
}

export const getProfessionalData = (): Professionals.Professional | null => {
	const professionalData = Cookies.get('professional_infos');
	return professionalData
		? (JSON.parse(professionalData) as Professionals.Professional)
		: null;
};

export const checkProfessionalAuthorization = ({
	handleFailed,
	handleProfessionalAuthorized,
	handleProfessionalNotAuthorized,
}: CheckProfessionalAuthorizationProps) => {
	const professionalData = getProfessionalData();
	if (professionalData) {
		if (professionalData.authorized) {
			handleProfessionalAuthorized && handleProfessionalAuthorized();
			return;
		} else {
			handleProfessionalNotAuthorized &&
				handleProfessionalNotAuthorized();
		}
	}
	handleFailed && handleFailed();
};

export const setProfessionalData = (
	professional: Professionals.Professional,
) => {
	Cookies.remove('user_infos');
	Cookies.set('professional_infos', JSON.stringify(professional));
};

export const removeProfessionalData = () => {
	Cookies.remove('professional_infos');
};

export const setUserData = (user: Users.User) => {
	Cookies.remove('professional_infos');
	Cookies.set('user_infos', JSON.stringify(user));
};

export const getUserData = (): Users.User | null => {
	const userData = Cookies.get('user_infos');
	return userData ? (JSON.parse(userData) as Users.User) : null;
};

export const removeUserData = () => {
	Cookies.remove('user_infos');
};

export const setAdminData = (admin: Admins.Admin) => {
	Cookies.set('admin_infos', JSON.stringify(admin));
};

export const removeAdminData = () => {
	Cookies.remove('admin_infos');
};

export const getCompanyData = (): Companies.Company | null => {
	const companyData = Cookies.get('company_infos');
	return companyData ? (JSON.parse(companyData) as Companies.Company) : null;
};

export const setCompanyData = (company: Companies.Company) => {
	Cookies.remove('user_infos');
	Cookies.remove('professional_infos');
	Cookies.set('company_infos', JSON.stringify(company));
};

export const removeCompanyData = () => {
	Cookies.remove('company_infos');
};
